/* eslint-disable */
import Html5 from './videoplayer/html5';
import LottiePlayer from './videoplayer/lottie';
import Yt from './videoplayer/yt';

class VideoPlayerFactory {

  constructor(){

  }

  getPlayer(container,videotype){

    let playerObject = null;

    switch (videotype) {
      case 'html5':
        playerObject = new Html5(container);
        break;
      case 'youtube':
        playerObject = new Yt(container);
        break;
      case 'lottie':
        playerObject = new LottiePlayer(container);
        break;
    }

    return playerObject;


  }

}

export default VideoPlayerFactory;



// WEBPACK FOOTER //
// ./scripts/classes/video-player-factory.js